import React, { useEffect, useState, useCallback, Fragment } from 'react';
import { useLocation } from 'react-router-dom';
import {
  Link,
} from "react-router-dom";
import './Header.css';
import i18n from '../i18n';
import LanguageSelect from '../language-select/LanguageSelect';
import SearchWindow from '../search-window/SearchWindow';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHeadset, faSearch, faUserCircle, faBars, faShoppingBasket, faTimes, faSignInAlt, faSignOutAlt, faJedi, faCaretRight, faCaretLeft, faSpinner, faDotCircle as faDotCircleSolid } from '@fortawesome/free-solid-svg-icons'
import { faClock, faHeart, faUserCircle as faUserCircleO, faDotCircle, } from '@fortawesome/free-regular-svg-icons'
import { faFacebook, faInstagram, faPinterest} from '@fortawesome/free-brands-svg-icons'
import request from '../request';
import storage from '../storage';
import logoImage from '../assets/img/logo-header.png';
import programImageEl from '../assets/img/program-banner-el.jpg';
import programImageEn from '../assets/img/program-banner-en.jpg';

function Header(props) {
  const [searchWindowOpen, setSearchWindowOpen] = useState(false);
  const [navMobileOpen, setNavMobileOpen] = useState(false);
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const [userMobileMenuOpen, setUserMobileMenuOpen] = useState(false);
  const [navigationMenuType, setNavigationMenuType] = useState(localStorage['navigation-menu-type'] || 'normal');
  const [categories, setCategories] = useState([]);
  const [fetchingCategories, setFetchingCategories] = useState(false);
  const [headerFixed, setHeaderFixed] = useState(localStorage['header-fixed'] || '0');

  const elementRef = React.createRef();

  const [, updateState] = useState();
  const forceUpdate = useCallback(() => updateState({}), []);

  useEffect(() => {
    const unlistenOnLanguageChange = i18n.onLanguageChange(() => {
      forceUpdate();
    });

    document.querySelector('.controls .user').addEventListener('click', function() {
      setUserMenuOpen(!document.querySelector('.controls .user .options').classList.contains('open'));
    });

    const onWindowClick = function(e) {
      if (!document.querySelector('.controls .user').contains(e.target)) {
        setUserMenuOpen(false);
      }
    };

    window.addEventListener('click', onWindowClick);

    document.querySelector('.navbar-mobile .controls .user').addEventListener('click', function() {
      setUserMobileMenuOpen(!document.querySelector('.controls .user .options').classList.contains('open'));
    });

    window.addEventListener('click', function(e) {
      if (!document.querySelector('.navbar-mobile .controls .user').contains(e.target)) {
        setUserMobileMenuOpen(false);
      }
    });

    setFetchingCategories(true);
    request.get(`api/categories`).then((response) => {
      let data = response.data;
      data = data.sort((a, b) => {
        if (parseInt(a.productsCount) > parseInt(b.productsCount)) {
          return -1;
        } else {
          return 1;
        }
      });
      setCategories(data);
      setFetchingCategories(false);
      storage.set('categories', data);
    });

    return () => {
      unlistenOnLanguageChange();
      window.removeEventListener('click', onWindowClick);
    };
  }, []);

  const location = useLocation();
  useEffect(() => {
    setNavMobileOpen(false);
  }, [location]);

  useEffect(() => {
    if (navMobileOpen) {
      const mobileNavBtnClosePos = elementRef.current.querySelector('.navbar-mobile .btn-close').getBoundingClientRect();
      elementRef.current.querySelector('.navbar-mobile .content').style.top = mobileNavBtnClosePos.top + mobileNavBtnClosePos.height + (window.innerHeight * 0.09) + 'px';
    }
  }, [navMobileOpen]);

  function closeSearchWindow() {
    setSearchWindowOpen(false);
  }

  function openMobileNavMenu() {
    setNavMobileOpen(true);
  }

  function closeMobileNavMenu() {
    setNavMobileOpen(false);
  }

  function changeNavigationMenuType(type) {
    setNavigationMenuType(type);
    localStorage.setItem('navigation-menu-type', type);
  }

  function changeHeaderFixed(state) {
    setHeaderFixed(state);
    localStorage.setItem('header-fixed', state);
    props.onHeaderTypeChange(state === '1' ? 'sticky' : 'normal');
  }

  function logout() {
    request.get('api/logout').then((response) => {
      if (response.data.status === 'ok') {
        props.onLogout();
      }
    });
  }

  let isLoggedIn = props.user.authenticated;
  const signinOptions = () => {
    if (isLoggedIn) {
      return  (<React.Fragment>
        <Link to="/account">
          <FontAwesomeIcon icon={faUserCircleO} />
          &nbsp;
          {i18n.t('my_account')}
        </Link>
        <Link to="" onClick={logout}>
          <FontAwesomeIcon icon={faSignOutAlt} />
          &nbsp;
          {i18n.t('signout')}
        </Link>
      </React.Fragment>);      
    } else {
      return  (
        <React.Fragment>
        <Link to="/signin">
          <FontAwesomeIcon icon={faSignInAlt} />
          &nbsp;
          {i18n.t('signin')}
        </Link>
        <Link to="/signup">
          <FontAwesomeIcon icon={faJedi} />
          &nbsp;
          {i18n.t('signup')}
        </Link>             
      </React.Fragment>);

    }
  }

  return (
    <div
      className={`header fixed`}
      ref={elementRef}
      style={{boxShadow: 'unset'}}
    >
      <div className="program-banner">          
        {i18n.language === 'el' && <a href="https://funky-office.gr/elianiko-el.pdf"><img src={programImageEl} alt="ESPA program banner" /></a>}
        {i18n.language === 'en' && <a href="https://funky-office.gr/elianiko-en.pdf"><img src={programImageEn} alt="ESPA program banner" /></a>}
      </div>
      <div className="topbar">
        <div className="info">
          <div className="entry">
            <FontAwesomeIcon icon={faClock} />
            <span>{i18n.t('visit_time')}:</span>
            <span>{`${i18n.t('monday_to_friday_and_hours')} ${storage.company.open_week}`}</span>
          </div>
          <div className="entry">
            <FontAwesomeIcon icon={faHeadset} />
            <span>{i18n.t('call_us')}:</span>
            <span>{storage.company.phone1}, {storage.company.cell1}</span>
          </div>
        </div>
        <div className="options">
          <LanguageSelect></LanguageSelect>
          <Link to="/contact">{i18n.t('contact')}</Link>
          {
            storage.company.social_facebook !== '' ?
            <a className="social-links" href={storage.company.social_facebook}><FontAwesomeIcon size="2x" icon={faFacebook} /></a> :
            ''
          }
          {
            storage.company.social_instagram !== '' ?
            <a className="social-links" href={storage.company.social_instagram}><FontAwesomeIcon size="2x" icon={faInstagram} /></a> :
            ''
          }
          {
            storage.company.social_pinterest !== '' ?
            <a className="social-links" href={storage.company.social_pinterest}><FontAwesomeIcon size="2x" icon={faPinterest} /></a> :
            ''
          }
          {/* <FontAwesomeIcon icon={faFacebook} /> */}
          {
            headerFixed === '0'
              ? <div className="change-header-type-option">
                  <FontAwesomeIcon
                    icon={faDotCircle}
                    className="btn-change-header-to-fixed"
                    onClick={() => changeHeaderFixed('1')}
                  />
                  <div className="tooltip">{i18n.t('change_header_to_fixed_tooltip')}</div>
                </div>
              : ''
          }
          {
            headerFixed === '1'
              ? <div className="change-header-type-option">
                  <FontAwesomeIcon
                    icon={faDotCircleSolid}
                    className="btn-change-header-to-normal"
                    onClick={() => changeHeaderFixed('0')}
                  />
                  <div className="tooltip">{i18n.t('change_header_to_normal_tooltip')}</div>
                </div>
              : ''
          }
        </div>
      </div>
      <div className="navbar">
        <div className="logo">
          <Link to="/">
            <img src={logoImage} height="100" alt="Funky office" />
            <span className="d-none">Funky office</span>
          </Link>
        </div>
        <div className="navigation">
          {
            navigationMenuType === 'normal'
              ? <Fragment>
                  <Link to="/">{i18n.t('home_page')}</Link>
                  <Link to="/products">{i18n.t('products_navigation')}</Link>
                  <Link to="/categories">{i18n.t('categories')}</Link>
                  <Link to="/contact">{i18n.t('contact')}</Link>
                  <Link to="/basket">{i18n.t('basket')}</Link>
                  <FontAwesomeIcon
                    icon={faCaretRight}
                    className="btn-swap-menu-to-categories"
                    onClick={() => changeNavigationMenuType('categories')}
                  />
                </Fragment>
              : ''
          }
          {
            navigationMenuType === 'categories'
              ? <Fragment>
                  <FontAwesomeIcon
                    icon={faCaretLeft}
                    className="btn-swap-menu-to-normal"
                    onClick={() => changeNavigationMenuType('normal')}
                  />
                  {
                    fetchingCategories
                      ? <Fragment>
                          <FontAwesomeIcon icon={faSpinner} className="fa-spin" />
                          <span>{i18n.t('fetching_categories')}</span>
                        </Fragment>
                      : ''
                  }
                  {
                    !fetchingCategories && categories.slice(0, 5).map((category, i) => {
                      return (
                        <Link
                          key={i}
                          to={`/categories/${category.id}`}
                        >
                          {category.name}
                        </Link>
                      );
                    })
                  }
                </Fragment>
              : ''
          }
        </div>
        <div className="controls">
          <div className="search">
            <FontAwesomeIcon
              icon={faSearch}
              size="lg"
              onClick={() => setSearchWindowOpen(true)}
            />
          </div>
          <div className="user">
            <FontAwesomeIcon
              icon={faUserCircle}
              size="lg"
            />
            <div 
              className={`options ${userMenuOpen ? 'open' : ''}`}
            >
              {signinOptions()}
            </div>
          </div>
          <div className="favourite">
            <Link to="/products">
              <FontAwesomeIcon
                icon={faHeart}    
                size="lg"         
              />
              <span className="d-none" style={{color: '#FFF'}}>Favourites</span>
            </Link>            
          </div>
          <div className="basket">
            <FontAwesomeIcon
              icon={faShoppingBasket}
              size="lg"
              onClick={props.onOpenBasket}
            />
          </div>
        </div>
        <div className="mobile-controls">
          <div className="btn-mobile-navigation">
            <FontAwesomeIcon
              icon={faBars}
              onClick={openMobileNavMenu}
            />
          </div>
        </div>
      </div>
      <div className={`navbar-mobile ${!navMobileOpen ? 'hidden' : ''}`}>
        <FontAwesomeIcon
          icon={faTimes}
          className="btn-close"
          onClick={closeMobileNavMenu}
        />
        <div className="content">
          <div className="controls">
            <div className="search">
              <FontAwesomeIcon
                icon={faSearch}
                size="2x"
                onClick={() => setSearchWindowOpen(true)}
              />
            </div>
            <div className="user">
              <FontAwesomeIcon
                icon={faUserCircle}
                size="2x"
              />
              <div 
                className={`options ${userMobileMenuOpen ? 'open' : ''}`}
              >
                {
                  props.user.authenticated === false
                    ? <Link to="/signin">
                        <FontAwesomeIcon icon={faSignInAlt} />
                        &nbsp;
                        {i18n.t('signin')}
                      </Link>
                    : ''
                }
                {
                  props.user.authenticated === false
                    ? <Link to="/signup">
                        <FontAwesomeIcon icon={faJedi} />
                        &nbsp;
                        {i18n.t('signup')}
                      </Link>
                    : ''
                }
                {
                  props.user.authenticated
                    ? <Link to="">
                        <FontAwesomeIcon icon={faUserCircleO} />
                        &nbsp;
                        {i18n.t('my_account')}
                      </Link>
                    : ''
                }
                {
                  props.user.authenticated
                    ? <Link to="">
                        <FontAwesomeIcon icon={faSignOutAlt} />
                        &nbsp;
                        {i18n.t('signout')}
                      </Link>
                    : ''
                }
              </div>
            </div>
            <div className="favorites">
              <Link to="/products">
                <FontAwesomeIcon
                  icon={faHeart}    
                  size="2x"         
                />
                <span className="d-none" style={{color: '#FFF'}}>Favourite Products</span>
              </Link>            
            </div>
            <div className="basket">
              <FontAwesomeIcon
                icon={faShoppingBasket}
                size="2x"
                onClick={props.onOpenBasket}
              />
            </div>
          </div>
          <div className="navigation">
            <Link to="/">{i18n.t('home_page')}</Link>
            <Link to="/products">{i18n.t('products_navigation')}</Link>
            <Link to="/categories">{i18n.t('categories')}</Link>
            <Link to="/contact">{i18n.t('contact')}</Link>
            <Link to="/basket">{i18n.t('basket')}</Link>
          </div>
        </div>
      </div>
      <SearchWindow 
        open={searchWindowOpen}
        onClose={closeSearchWindow}
      />
    </div>
  );
}

export default Header;
